import { useMemo, type ReactNode } from "react";
import { FeatureFlagContext, FLAG_DEFAULTS, type FeatureFlags } from "@/hooks/useFeatureFlags.tsx";
import { useFeatures } from "@/hooks/useFeatures.ts";

interface FeatureFlagProviderProps {
  readonly overrides?: Partial<FeatureFlags>;
  readonly children: ReactNode;
}

/**
 * Static defaults, then the per-environment values from the BFF's /features (off until it
 * answers), then `overrides`.
 */
export default function FeatureFlagProvider({ overrides, children }: FeatureFlagProviderProps) {
  const { data: features } = useFeatures();
  const alerts = features?.alerts ?? FLAG_DEFAULTS.alerts;
  const vulnWatch = features?.vuln_watch ?? FLAG_DEFAULTS.vulnWatch;
  const flags = useMemo(
    () => ({ ...FLAG_DEFAULTS, alerts, vulnWatch, ...overrides }),
    [alerts, vulnWatch, overrides],
  );

  return <FeatureFlagContext.Provider value={flags}>{children}</FeatureFlagContext.Provider>;
}
